import {useState} from 'react';
import {useMutation} from '@apollo/client';
import {Modal, Tag, Select, Descriptions, Divider, Button} from 'antd';
import {toast} from 'react-toastify';
import {UPDATE_ACTION_ITEM} from 'graphql/queries/users';

const InteractionActionDetailModal = ({
  isOpen,
  onClose,
  actionItem,
  onStatusUpdated,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [updateActionItem, {loading: updating}] = useMutation(
    UPDATE_ACTION_ITEM,
    {
      onCompleted: data => {
        if (data?.updateActionItemStatus?.__typename === 'Error') {
          toast.error(data.updateActionItemStatus.message);
          return;
        }
        toast.success('Action item status updated successfully');
        setSelectedStatus(null);
        if (onStatusUpdated) onStatusUpdated();
      },
      onError: error => {
        toast.error(`Update failed: ${error.message}`);
        setSelectedStatus(null);
      },
    },
  );

  if (!actionItem) return null;

  const handleStatusChange = newStatus => {
    const previousStatus = actionItem.status || 'not_started';
    if (newStatus === previousStatus) return;

    setSelectedStatus(newStatus);
    console.log(actionItem);

    Modal.confirm({
      title: 'Confirm status update',
      content: 'Are you sure you want to update this action item status?',
      okText: 'Update Status',
      cancelText: 'Cancel',
      onCancel: () => setSelectedStatus(null),
      onOk: () =>
        updateActionItem({
          variables: {
            interactionId: actionItem.interactionId,
            actionItem: {
              actionItemId: actionItem.id,
              status: newStatus,
            },
          },
        }),
    });
  };

  const getPriorityColor = priority => {
    switch (priority) {
      case 'URGENT':
        return 'error';
      case 'HIGH':
        return 'warning';
      case 'MEDIUM':
        return 'processing';
      case 'LOW':
        return 'default';
      default:
        return 'default';
    }
  };

  return (
    <Modal
      title="Interaction Action Detail"
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={600}>
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '16px',
          }}>
          <h3 style={{margin: 0, fontSize: '18px'}}>{actionItem.title}</h3>
          <Tag color={getPriorityColor(actionItem.priority)}>
            {actionItem.priority}
          </Tag>
        </div>

        <p
          style={{
            color: '#64748b',
            fontSize: '14px',
            lineHeight: '1.6',
            marginBottom: '24px',
          }}>
          {actionItem.description}
        </p>

        <Divider />

        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label="Category">
            {actionItem.category}
          </Descriptions.Item>
          <Descriptions.Item label="Current Status">
            <Select
              value={selectedStatus || actionItem.status || 'not_started'}
              style={{width: 160}}
              onChange={handleStatusChange}
              loading={updating}
              disabled={updating}>
              <Select.Option value="not_started">Not Started</Select.Option>
              <Select.Option value="in_progress">In Progress</Select.Option>
              <Select.Option value="done">Completed</Select.Option>
              <Select.Option value="cancelled">Cancelled</Select.Option>
            </Select>
          </Descriptions.Item>
          <Descriptions.Item label="Due Date">
            {actionItem.dueDate
              ? new Date(actionItem.dueDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
              : 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="Interaction ID">
            <span style={{fontSize: '11px', color: '#94a3b8'}}>
              {actionItem.interactionId}
            </span>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Modal>
  );
};

export default InteractionActionDetailModal;
